import { colors } from '../../colors';
var address = {
  addressColor: colors.nvaBlack
};
export default address;